import { CHAT_NUMBER_STATUSES, type ChatNumberStatus } from '~/features/whatsapp/constants/chatNumberStatus';

export const isForeignNumber = (chatPhoneNumberId: string, ownPhoneNumberId: string | null | undefined): boolean =>
    Boolean(ownPhoneNumberId) && chatPhoneNumberId !== ownPhoneNumberId;

// undefined when own number is unknown (loading, admin, no division number) and the sender is reachable
export const resolveChatNumberStatus = ({
    chatPhoneNumberId,
    ownPhoneNumberId,
    senderUnavailable,
}: {
    chatPhoneNumberId: string;
    ownPhoneNumberId: string | null | undefined;
    senderUnavailable: boolean;
}): ChatNumberStatus | undefined => {
    if (senderUnavailable) return CHAT_NUMBER_STATUSES.UNAVAILABLE;
    if (!ownPhoneNumberId) return undefined;
    return isForeignNumber(chatPhoneNumberId, ownPhoneNumberId)
        ? CHAT_NUMBER_STATUSES.FOREIGN
        : CHAT_NUMBER_STATUSES.CURRENT;
};
